// extracted by mini-css-extract-plugin
export var banner = "_dn-0";
export var closeButton = "_dn-2";
export var greenCheckmark = "_dn-3";
export var hereLink = "_dn-4";
export var titleIcon = "_dn-1";